// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"8ed8f810","45":"3b278c92","207":"96d48f18","307":"d2ddd7a6","485":"3b278c92","631":"3b278c92","640":"3b278c92","950":"d0eaccf0","994":"7046b18d"}[chunkId] + ".chunk.css";
};